
export default () => ({
    loading: true,
    trails: [],
    currentTrail: null
})
